//小组详情
<template>
  <div class="viewdetails">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="已审" disabled name="first">已审</el-tab-pane>
      <el-tab-pane label="待审" disabled name="second">待审</el-tab-pane>
      <el-tab-pane label="回收站" disabled name="third">回收站</el-tab-pane>
      <el-tab-pane label="添加" disabled name="fourth">添加</el-tab-pane>
      <el-tab-pane label="导出" disabled name="fifth ">导出</el-tab-pane>
      <el-tab-pane label="查看详情" name="sixth">
        <div class="underline">
          <el-form ref="form" label-width="100px" size="mini" :inline="false">
            <div class="underline-first">
              <el-form-item label="类型:">
                <div v-if="form.type == 0">在线学习</div>
              </el-form-item>
            </div>
            <div class="underline-item">
              <el-form-item label="小组名称:">{{form.name}}</el-form-item>
            </div>

            <div class="underline-item">
              <el-form-item label="办学单位:">{{form.schoolUnit}}</el-form-item>
            </div>

            <div class="underline-item">
              <el-form-item label="指导老师:">{{form.teacherNames}}</el-form-item>
            </div>

            <div class="underline-item">
              <el-form-item label="学生:">{{form.studentNames}}</el-form-item>
            </div>
          </el-form>
        </div>
        <el-button type="primary" @click="cancel" style=" margin-left:15px; margin-top:10px;padding-left: 18px;">
          返回
        </el-button>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { confirmMsg } from "@/utils/common";
import * as api from "@/api/group/api";
export default {
  name: "View-details",
  components: {},
  data() {
    return {
      activeName: "sixth",
      form: {
        type: "在线学习",
        name: "组1",
        schoolUnit: "华南理工大学",
        teacherNames: "",
        studentNames: "",
      },
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
   //取消
    cancel(){
       history.go(-1)
    },
    getParams() {
      const routerParams = this.$route.query;
      api.jsonString
      this.form = JSON.parse(this.$route.query.jsonString);
      console.log(this.form);
      console.log(this.form.name);
    },
  },
  beforeCreate() {
    console.log(1);
  },
  created() {
    console.log(2);
    this.getParams();
  },
  mounted() {},
};
</script>
<style lang='scss' scoped>
.underline {
  box-sizing: border-box;
  padding-top: 10px;
}
.underline-first {
  border-bottom: 1px solid rgb(52, 159, 247);
}
.underline-item {
  border-bottom: 1px solid #b3b4b6;
  padding-bottom: 20px;
  padding-top: 15px;
}
</style>
